import { Container } from "react-bootstrap";
import TabComponent from "../common/TabComponent";
import { useEffect, useState } from 'react';
import { apiService } from "../service/api.service";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from "moment";
import Loader from "../common/Loader";
import Pagination from "react-js-pagination";

const TransactionHistory = () => {
  const [loader, setLoader] = useState(false);
  const [transactionData, settransactionData] = useState();
  const [page, setpage] = useState(0);
  const [size, setsize] = useState(10);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [totalItems, settotalItem] = useState(0);

  useEffect(() => {
    getTransaction(page, size);
  }, []);

  const handleApply = () => {
    getTransaction(page, size);
  };

  function clear() {
    setStartDate(null);
    setEndDate(null);
    getTransaction(page, size);
  }

  const handleStartDateChange = date => {
    if (!date) {
      setStartDate(null);
      return;
    }
    date = new Date(date);
    let dt = moment(date).format("YYYY-MM-DD");
    setStartDate(dt);
  };

  const handleEndDateChange = date => {
    if (!date) {
      setEndDate(null);
      return;
    }
    date = new Date(date);
    let dt = moment(date).format("YYYY-MM-DD");
    setEndDate(dt);
  };

  function handlePageChange(pageNumber) {
    setpage(pageNumber - 1);
    getTransaction(pageNumber - 1, size);
  }

  const getTransaction = (page, size) => {
    setLoader(true);
    let queryParam = ``;
    if (startDate && endDate) {
      queryParam = `?from=${startDate}&to=${endDate}`;
    }
    apiService.orderTransaction(page, size, queryParam).then((res) => {
      settotalItem(res.data.data.total);
      setLoader(false);
      settransactionData(res.data.data.list);
    }).catch((err) => {
      setLoader(false);
    });
  };

  const startItem = transactionData && transactionData.length > 0 ? page * size + 1 : 0;
  const endItem = transactionData && transactionData.length > 0 ? Math.min((page + 1) * size, totalItems || transactionData.length) : 0;

  return (
    <>
      {loader && <Loader />}
      <div className="height-footer dashboard-page">
        <Container>
          <div className="dashboard-shell">
            <div className="dashboard-sidebar">
              <TabComponent />
            </div>
            <div className="dashboard-main">
              <div className="tab-pane" id="dashboard">
                <div className='product-management common-under-padding'>
                  {/* Top Control Bar Header */}
                  <div className='product-header-area status-bar'>
                    <div className='under-heading w-100 d-flex align-items-center justify-content-between flex-wrap gap-3'>
                      <div className="date-range-filter-modern">
                        <div className="pick-date-item">
                          <label>From:</label>
                          <div className="pick-date-input-wrap">
                            <DatePicker
                              selected={startDate}
                              onChange={date => handleStartDateChange(date)}
                              selectsStart
                              startDate={startDate}
                              endDate={endDate}
                              placeholderText="From Date"
                            />
                            <i className="fa fa-calendar" aria-hidden="true"></i>
                          </div>
                        </div>

                        <div className="pick-date-item">
                          <label>To:</label>
                          <div className="pick-date-input-wrap">
                            <DatePicker
                              selected={endDate}
                              onChange={date => handleEndDateChange(date)}
                              endDate={endDate}
                              minDate={startDate}
                              placeholderText="To Date"
                            />
                            <i className="fa fa-calendar" aria-hidden="true"></i>
                          </div>
                        </div>

                        <button onClick={handleApply} className="apply-btn-green">Apply</button>
                        <button onClick={clear} className="clear-btn-light">Clear</button>
                      </div>
                    </div>
                  </div>

                  {/* Transaction Table Card Container */}
                  <div className="product-table-container-card">
                    <div className="table-responsive">
                      <table className="table product-view-table">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Transaction ID</th>
                            <th>Gross Amount</th>
                            <th>Platform Fee</th>
                            <th>Earnings</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {transactionData && transactionData.map((data, index) => {
                            const formattedGross = data.grossAmount ? `$${data.grossAmount.toFixed(2)}` : "$0.00";
                            const formattedFee = data.platformFee ? `-$${data.platformFee.toFixed(2)}` : "$0.00";
                            const formattedNet = data.netAmount ? `$${data.netAmount.toFixed(2)}` : "$0.00";

                            return (
                              <tr key={data.transactionId || index}>
                                <td>
                                  <div className="date-time-stack">
                                    <span className="date-bold">
                                      {moment(data?.transactionDate).format("MMM DD, YYYY")}
                                    </span>
                                    <span className="time-muted">
                                      {moment(data?.transactionDate).format("hh:mm A")}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <span className="product-id-cell">{data.transactionId || "—"}</span>
                                </td>
                                <td>
                                  <span className="product-title-bold">{formattedGross}</span>
                                </td>
                                <td>
                                  <span className="red-fee-text">{formattedFee}</span>
                                </td>
                                <td>
                                  <span className="price-green-bold">{formattedNet}</span>
                                </td>
                                <td>
                                  {data.status === "SUCCESS" ? (
                                    <span className="status-pill status-pill-success">
                                      <span className="dot-indicator"></span>
                                      Received
                                    </span>
                                  ) : (
                                    <span className="status-pill status-pill-warning">
                                      <span className="dot-indicator"></span>
                                      {data.status || "Pending"}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    {transactionData && transactionData.length === 0 && (
                      <div className="nodata centre p-4">
                        <img src={require("../assets/images/no-data-found.png")} alt="img" />
                        <span>No data Found</span>
                      </div>
                    )}

                    {/* Table Footer */}
                    {transactionData && transactionData.length > 0 && (
                      <div className="product-table-card-footer">
                        <div className="showing-info-txt">
                          Showing {startItem} to {endItem} of {totalItems || transactionData.length} transactions
                        </div>
                        {totalItems > size && (
                          <div className="modern-pagination-tab">
                            <Pagination
                              activePage={page + 1}
                              itemsCountPerPage={size}
                              totalItemsCount={totalItems}
                              pageRangeDisplayed={5}
                              onChange={(e) => handlePageChange(e)}
                              prevPageText="<"
                              nextPageText=">"
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default TransactionHistory;
